/**
 * @generated SignedSource<<121fb488b6b69ad4f77a2f04f366e101>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuizSubmissionsTable_PaginationFragment$data = {
  readonly id: string;
  readonly submissions: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionsTableRow_submission">;
      };
    }>;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
    readonly totalCount: number;
  };
  readonly " $fragmentType": "QuizSubmissionsTable_PaginationFragment";
};
export type QuizSubmissionsTable_PaginationFragment$key = {
  readonly " $data"?: QuizSubmissionsTable_PaginationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuizSubmissionsTable_PaginationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "submissions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "completedAfter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentUsageId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isComplete"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isFailed"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isPassed"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "membersOnly"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "percentageGreaterThanOrEqual"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "percentageLessThan"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "bidirectional",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": {
          "count": "last",
          "cursor": "before"
        },
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./QuizSubmissionsTablePaginationQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "QuizSubmissionsTable_PaginationFragment",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "submissions",
      "args": [
        {
          "kind": "Variable",
          "name": "completedAfter",
          "variableName": "completedAfter"
        },
        {
          "kind": "Variable",
          "name": "isComplete",
          "variableName": "isComplete"
        },
        {
          "kind": "Variable",
          "name": "isFailed",
          "variableName": "isFailed"
        },
        {
          "kind": "Variable",
          "name": "isPassed",
          "variableName": "isPassed"
        },
        {
          "kind": "Variable",
          "name": "membersOnly",
          "variableName": "membersOnly"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "percentageGreaterThanOrEqual",
          "variableName": "percentageGreaterThanOrEqual"
        },
        {
          "kind": "Variable",
          "name": "percentageLessThan",
          "variableName": "percentageLessThan"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "WebFormSubmissionNodeConnection",
      "kind": "LinkedField",
      "name": "__QuizSubmissionsTable_submissions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "WebFormSubmissionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormSubmission",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "QuizSubmissionsTableRow_submission"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfoObjectType",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasPreviousPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebFormRevision",
  "abstractKey": null
};
})();

(node as any).hash = "7daea8c0254ac1581ecaccd28ec15866";

export default node;
